/* env browser */
import Crypto from '@acsam/crypto/dist/js/esm/native.crypto';
import {
  basicSettings,
  defaultState,
  privacySettings,
} from '../constants';
import {
  CommandQueue,
  Debugger,
  Http,
  Relay,
  Store,
} from '../common';
import {
  ClrData,
  ClsData,
} from '../models';
import { Sensor } from '../sensor';

let global;
if ('IMAGlobalObject' in window) {
  global = window[window.IMAGlobalObject];
}
if ('ACSAMGlobalObject' in window) {
  global = window[window.IMAGlobalObject];
}
if (!global) {
  global = window.acsam || window.ima;
}
/**
 * Sensor factory. Creates a new sensor instance
 *
 * @return {Sensor} - Sensor instance
 */
const createSensor = () => new Sensor(
  {
    basicSettings,
    defaultState,
    privacySettings,
  },
  new Debugger(basicSettings),
  Crypto,
  {
    ClrData,
    ClsData,
    Http,
    Relay,
    Store,
  },
);
// Specify the rsa padding mode which is in native implementation 1 (RSA-OAEP)
basicSettings.rsaPadding = 1;
// Set script type to modern
basicSettings.scriptType = 'modern';
// Set script crypto library to native
basicSettings.cryptoLibrary = 'n';

/**
 * Initializes a new command queue instance which will orchestrate the queue with the logic to execute public methods from the tracker instance when
 * a command will be pushed to the queue
 *
 * @type {CommandQueue}
 */
global.q = new CommandQueue(global.q, createSensor);
// Flush the command queue
global.q.dequeue();

// Add a method for creating a new sensor instance
global.createSensor = createSensor;
